<template>
  <div class="justify-center page">
    <div class="flex-col group">
      <span class="text">行言君商城</span>
      <div class="divider"></div>
      <span class="text_1">伴你每一天</span>
    </div>
    <div class="flex-row group_1">
      <div class="flex-col section_1">
        <span class="text_2">商家入驻</span>
        <div class="flex-row group_2">
          <div class="flex-col items-center group_3">
            <span>用户名</span>
            <span class="text_4">密码</span>
            <span class="text_5">确认密码</span>
            <span class="text_6">邮箱</span>
          </div>
          <img src="../assets/16492134146070867145.png" class="image" />
        </div>
        <div class="flex-row group_4">
          <span class="text_7">营业执照</span>
          <div class="flex-col items-center text-wrapper">
            <span>选择文件</span>
          </div>
        </div>
        <div class="flex-row divider_1">
          <img src="../assets/16492134146078913630.png" class="image_1" />
          <span class="text_9">同意“使用用户协议”</span>
        </div>
        <div class="flex-col items-center text-wrapper_1">
          <span>提交</span>
        </div>
      </div>
      <div class="flex-col section_2">
        <img src="../assets/16492309819377143283.png" class="image_2" />
        <span class="text_11">入驻成功</span>
        <div @click="view_9OnClick" class="flex-col items-center text-wrapper_2">
          <span>返回首页</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    methods: {
      view_9OnClick() {
        this.$router.push({ name: 'wenju' });
      },
    },
  };
</script>

<style scoped lang="css">
  .page {
    padding: 2.16rem 3.19rem 1.75rem;
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    height: 100%;
  }
  .group {
    margin-top: 2.13rem;
    width: 4.72rem;
  }
  .group_1 {
    margin-left: 1rem;
    width: 6.88rem;
  }
  .text {
    color: rgb(71, 170, 52);
    font-size: 0.69rem;
    font-weight: 700;
    line-height: 0.69rem;
    white-space: nowrap;
  }
  .divider {
    margin-top: 0.28rem;
    background-color: rgb(71, 170, 52);
    height: 0.063rem;
  }
  .text_1 {
    margin-top: 0.22rem;
    color: rgb(71, 170, 52);
    font-size: 0.34rem;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .section_1 {
    margin-left: 1.94rem;
    padding: 0.88rem 0.44rem 1.09rem 0.44rem;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0.021rem 0.17rem 0px rgba(71, 170, 52, 0.44);
    border-radius: 0.25rem;
    width: 4.94rem;
    height: 7.31rem;
  }
  .section_2 {
    margin-left: -6.88rem;
    margin-top: 1.75rem;
    padding: 0.41rem 0.5rem 0.34rem 0.5rem;
    color: rgb(255, 255, 255);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0.45);
    border-radius: 0.13rem;
    width: 2.22rem;
    height: 2.69rem;
  }
  .text_2 {
    align-self: center;
    color: rgb(83, 194, 61);
    font-size: 0.34rem;
    font-weight: 700;
    line-height: 0.34rem;
    white-space: nowrap;
  }
  .group_2 {
    margin-top: 0.5rem;
    color: rgb(95, 100, 99);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .group_4 {
    margin-top: 0.22rem;
  }
  .divider_1 {
    margin-top: 0.19rem;
    padding: 0 0.75rem;
    color: rgb(95, 100, 99);
    font-size: 0.16rem;
    font-weight: 600;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text-wrapper_1 {
    margin-top: 0.69rem;
    padding: 0.13rem 0;
    align-self: center;
    color: rgb(255, 255, 255);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgb(83, 194, 61);
    border-radius: 0.063rem;
    width: 1.88rem;
  }
  .image_2 {
    align-self: center;
    border-radius: 50%;
    width: 0.78rem;
    height: 0.78rem;
  }
  .text_11 {
    margin-top: 0.094rem;
    align-self: center;
  }
  .text-wrapper_2 {
    margin-top: 0.56rem;
    padding: 0.063rem 0;
    background-color: rgb(83, 194, 61);
    border-radius: 0.031rem;
    width: 1.22rem;
  }
  .group_3 {
    margin: 0.094rem 0 0.094rem;
    width: 0.63rem;
  }
  .image {
    margin-left: 0.13rem;
    margin-right: 0.41rem;
    width: 2.94rem;
    height: 2.31rem;
  }
  .text_7 {
    margin: 0.094rem 0 0.094rem;
    color: rgb(95, 100, 99);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
  }
  .text-wrapper {
    margin-left: 0.094rem;
    color: rgb(197, 203, 202);
    font-size: 0.16rem;
    line-height: 0.22rem;
    white-space: nowrap;
    background-color: rgb(255, 255, 255);
    border-radius: 0.031rem;
    width: 1rem;
    height: 0.41rem;
    border: solid 0.063rem rgb(221, 221, 221);
  }
  .image_1 {
    width: 0.16rem;
    height: 0.16rem;
  }
  .text_9 {
    margin-left: 0.094rem;
  }
  .text_4 {
    margin-top: 0.44rem;
  }
  .text_5 {
    margin-top: 0.44rem;
  }
  .text_6 {
    margin-top: 0.44rem;
  }
</style>